import { PatientFile } from '@/core/graphql/types'
import { useMyInfosLoader } from '@/shared/api/myInfos'

export function useDashboard() {
  const myInfos = useMyInfosLoader()

  const consultations = myInfos?.consultations || []
  const expertises = myInfos?.expertises || []
  const files =
    myInfos?.files?.filter(isValidFile).map((file) => ({
      filename: file.filename,
      key: file.key,
      url: file.url,
    })) ?? []
  const formSubmissions = myInfos?.formSubmissions || []
  const orders = myInfos?.orders || []
  const patientId = myInfos?._id
  const firstName = myInfos?.userInfo?.name ?? ''

  return {
    consultations,
    expertises,
    files,
    firstName,
    formSubmissions,
    orders,
    patientId,
  }
}

// Type guard function
function isValidFile(file: PatientFile): file is PatientFile & { url: string } {
  return typeof file.url === 'string' && file.url !== ''
}
